import axiosInstance from "./AxiosInstance";

const getCurrentTime = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(now.getDate()).padStart(2, "0")} ${String(
    now.getHours()
  ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
    now.getSeconds()
  ).padStart(2, "0")}`;
};
export const createMotivationalPlan = async () => {
  try {
    const response = await axiosInstance.post(
      "api/motivational-coach/create-plan",
      {
        start_time: getCurrentTime(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating motivational coach plan:", error);
    throw error;
  }
};

export const fetchMotivationalData = async () => {
  try {
    const response = await axiosInstance.get("api/motivational-coach");
    return response.data;
  } catch (error) {
    console.error("Error fetching motivational coach data:", error);
    throw error;
  }
};
